export function getHeartbeatWsUrl(answerId) {
  if (!answerId) {
    return ''
  }

  if (process.env.NODE_ENV === 'development') {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    return `${protocol}//${window.location.host}/api/api/ws/heartbeatCheck?answerId=${answerId}`
  }

  const apiUrl = (process.env.VUE_APP_API_URL || 'https://zhuce.qrorder.icu/').replace(/\/$/, '')
  const wsProtocol = apiUrl.startsWith('https') ? 'wss' : 'ws'
  const host = apiUrl.replace(/^https?:\/\//, '')
  return `${wsProtocol}://${host}/api/ws/heartbeatCheck?answerId=${answerId}`
}

export function connectHeartbeatWs(answerId) {
  const url = getHeartbeatWsUrl(answerId)
  if (!url) {
    return null
  }
  return new WebSocket(url)
}

export function closeHeartbeatWs(ws) {
  if (!ws) {
    return
  }
  if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
    ws.close()
  }
}
